import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaMedal } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchLeaderboard } from '../../store/reducers/leaderboardSlice';
import './Leaderboard.css';

const Leaderboard: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { rankedResponse, totalCount, isLoading, error } = useAppSelector(
    (state) => state.leaderboard
  );

  useEffect(() => {
    dispatch(fetchLeaderboard({ sortBy: '-numberOfProperties' }));
  }, [dispatch]);

  return (
    <div className="lb-container">
      <div className="lb-card">
        <header className="lb-header">
          <FaArrowLeft
            className="lb-back-icon"
            onClick={() => navigate(-1)}
          />
          <h2 className="lb-title">Leaderboard</h2>
        </header>

        <div className="lb-body">
          {isLoading && <div className="lb-loading">Loading…</div>}
          {error && <div className="lb-error">Error: {error}</div>}
          {!isLoading && !error && rankedResponse.length === 0 && (
            <div className="lb-empty">No entries yet</div>
          )}

          {!isLoading && !error && rankedResponse.length > 0 && (
            <ul className="lb-list">
              {rankedResponse.map((entry) => (
                <li key={entry._id} className="lb-item">
                  <div className="lb-rank">
                    <FaMedal /> #{entry.rank}
                  </div>
                  <div className="lb-user">
                    <span className="lb-fullname">{entry.fullName}</span>
                    <span className="lb-username">@{entry.userName}</span>
                  </div>
                  <div className="lb-stats">
                    <div className="lb-price">
                      ${entry.totalPropertyPrice.toFixed(2)}
                    </div>
                    <div className="lb-count">
                      {entry.numberOfProperties} properties
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
